<div class="notification-setting" *ngIf="notificationSetting">
  <div class="notification-setting-title">{{'notification_settings.title' | translate}}</div>
  <div class="notification-setting-form">
    <div class="notification-form-field">
      <label class="notification-label">{{'notification_settings.activity.label' | translate}}</label>
      <achoo-filter-box class="notification-dropdown"
                        [options]="activitySettings"
                        [(model)]="notificationSetting.activity"
                        placeholder="{{'notification_settings.activity.placeholder' | translate}}">
      </achoo-filter-box>
    </div>
    <div class="notification-form-field">
      <label class="notification-label">{{'notification_settings.updates.label' | translate}}</label>
      <achoo-filter-box class="notification-dropdown"
                        [options]="updateSettings"
                        [(model)]="notificationSetting.updates"
                        placeholder="{{'notification_settings.updates.placeholder' | translate}}">
      </achoo-filter-box>
    </div>
    <div class="notification-form-field">
      <label class="notification-label">{{'notification_settings.pending_action.label' | translate}}</label>
      <achoo-filter-box class="notification-dropdown"
                        [options]="pendingActions"
                        [(model)]="notificationSetting.pendingAction"
                        placeholder="{{'notification_settings.pending_action.placeholder' | translate}}">
      </achoo-filter-box>
    </div>
    <div class="notification-form-field">
      <label class="notification-label">{{'notification_settings.promotional_content.label' | translate}}</label>
      <achoo-filter-box class="notification-dropdown"
                        [options]="promotionalContents"
                        [(model)]="notificationSetting.promotionalEmails"
                        placeholder="{{'notification_settings.promotional_content.placeholder' | translate}}">
      </achoo-filter-box>
    </div>
  </div>
</div>
<achoo-popup #NotificationSettings
             [isNotification]="true"
             [modelTitle]="notificationStatus">
  <span>{{notificationMessage}}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/account-setting/user-settings/notification-setting/notification-setting.component.html